import { get } from "@crunchit/http-client";
import { IBlockedChoice, IBlockedProduct } from "@crunchit/types";
import { getToken, getEnvironment } from "utils/helpers/service";

const api = process.env.REACT_APP_WAREHOUSE_URI || `warehouse.${getEnvironment()}crunchy.ninja/api`;

const WarehouseService = {
  getBlockedProducts: async (productionUnitId: number) => {
    return get<IBlockedProduct[]>(`${api}/blockedProduct?productionUnitId=${productionUnitId}`, getToken());
  },
  getBlockedChoices: async (productionUnitId: number) => {
    return get<IBlockedChoice[]>(`${api}/blockedChoice?productionUnitId=${productionUnitId}`, getToken());
  },
};

export default WarehouseService;
